// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"uL-z","carouselContainer":"vL-z"};